
export const track={
    'track1': [
        'Software reliability and Quality Assurance',
        'Optimal Testing and System Software ',
        'Blockchain Technologies',
        'Cloud and Edge Computing',
        'Parallel and Distributed Computing',
        'Ubiquitous/Mobile Computing'
    ],
    'track2':[
        'Wireless Communication',
        '5G and 6G Technologies',
        'Cyber Security',
        'Big Data Analytics',
        'IoT Security, Privacy and Governance',
        'Mobile Systems and Mobility'
    ],
    'track3':[
        'Augmented and Virtual Reality',
        'Natural Language Processing ',
        'Transfer, Deep and Federated Learning',
        'AI in Robotics and Automation',
        'Heuristics and AI Planning',
        'Zero-Shot, One-Shot and Few-Shot Learning'
    ],
    'track4':[
        'Signal and Image Processing',
        'Image Restoration and Reconstruction ',
        'Image De-noising and Super resolution',
        'Image Segmentation, Recognition and Classification',
        'Object Tracking',
        'Medical Image Processing'
    ]

}

export const dateData=[
    {heading: 'Paper Submission Deadline', dateEvent: '24 January, 2025 ', extension: '8 February 2025', hardexten: '18 February 2025', status: 'Disable', color: 'danger' },
    {heading: 'Notification of Acceptance', dateEvent: '17 April, 2025', extension: '30 April 2025', status: 'Disable', color: 'success' },
    {heading: 'Camera-Ready Submission', dateEvent: '25 May, 2025', status: 'Active', color: 'info',  extension: '', hardexten: '' },
    // {heading: 'Early Bird Registration', dateEvent: '31 May, 2025', status: 'Active', color: 'danger' },
    {heading: 'Registration Deadline', dateEvent: '25 May, 2025', status: 'Active', color: 'success' },
    {heading: 'Conference Date', dateEvent: '27-28 June 2025', status: 'Active', color: 'danger' },
]

export const papers=[
    {id: 134},
    {id: 137},
    {id: 139},
    {id: 164},
    {id: 174},
    {id: 184},
    {id: 194}
]



export const tk_lists_earlyUp=[
    {name: 'General Author/Local', amount: 10000, short_code: 'BDT', type: 'AUTHOR'},
    {name: 'General Author/Local/ IEEE Member', amount: 9500, short_code: 'BDT', type: 'AUTHOR'},
    {name: 'General Author/SAARC Country', amount: 300, short_code: 'USD', type: 'AUTHOR'},
    {name: 'General Author/SAARC Country/IEEE Member', amount: 300, short_code: 'USD', type: 'AUTHOR'},
    {name: 'General Author/Other Countries',amount: 325, short_code: 'USD', type: 'AUTHOR'},
    {name: 'General Author/Other Countries/IEEE Member',amount: 325, short_code: 'USD', type: 'AUTHOR'},

    {name: 'General Attendee/Local', amount: 7500, short_code: 'BDT', type: 'ATTENDEE'},
    {name: 'General Attendee/SAARC Country', amount: 200, short_code: 'USD', type: 'ATTENDEE'},
    {name: 'General Attendee/Other Countries',amount: 250, short_code: 'USD', type: 'ATTENDEE'},

    {name: 'Student  Author/Local', amount: 8500, short_code: 'BDT', type: 'AUTHOR'},
    {name: 'Student  Author/Local/ IEEE Member', amount: 7500, short_code: 'BDT', type: 'AUTHOR'},
    {name: 'Student  Author/SAARC Country', amount: 225, short_code: 'USD', type: 'AUTHOR'},
    {name: 'Student  Author/SAARC Country/IEEE Member', amount: 225, short_code: 'USD', type: 'AUTHOR'},
    {name: 'Student  Author/Other Countries',amount: 250, short_code: 'USD', type: 'AUTHOR'},
    {name: 'Student  Author/Other Countries/IEEE Member',amount: 250, short_code: 'USD', type: 'AUTHOR'},

    {name: 'Student Attendee/Local', amount: 5500, short_code: 'BDT', type: 'ATTENDEE'},
    {name: 'Student Attendee/SAARC Country', amount: 130, short_code: 'USD', type: 'ATTENDEE'},
    {name: 'Student Attendee/Other Countries',amount: 160, short_code: 'USD', type: 'ATTENDEE'},
]

export const tk_lists_early=[
    {name: 'General Author/Local', amount: 10500, short_code: 'BDT', type: 'AUTHOR'},
    {name: 'General Author/Local/ IEEE Member', amount: 10000, short_code: 'BDT', type: 'AUTHOR'},
    {name: 'General Author/SAARC Country', amount: 325, short_code: 'USD', type: 'AUTHOR'},
    {name: 'General Author/SAARC Country/IEEE Member', amount: 325, short_code: 'USD', type: 'AUTHOR'},
    {name: 'General Author/Other Countries',amount: 350, short_code: 'USD', type: 'AUTHOR'},
    {name: 'General Author/Other Countries/IEEE Member',amount: 350, short_code: 'USD', type: 'AUTHOR'},

    {name: 'General Attendee/Local', amount: 8500, short_code: 'BDT', type: 'ATTENDEE'},
    {name: 'General Attendee/SAARC Country', amount: 225, short_code: 'USD', type: 'ATTENDEE'},
    {name: 'General Attendee/Other Countries',amount: 250, short_code: 'USD', type: 'ATTENDEE'},

    {name: 'Student  Author/Local', amount: 9500, short_code: 'BDT', type: 'AUTHOR'},
    {name: 'Student  Author/Local/ IEEE Member', amount: 9000, short_code: 'BDT', type: 'AUTHOR'},
    {name: 'Student  Author/SAARC Country', amount: 250, short_code: 'USD', type: 'AUTHOR'},
    {name: 'Student  Author/SAARC Country/IEEE Member', amount: 250, short_code: 'USD', type: 'AUTHOR'},
    {name: 'Student  Author/Other Countries',amount: 300, short_code: 'USD', type: 'AUTHOR'},
    {name: 'Student  Author/Other Countries/IEEE Member',amount: 300, short_code: 'USD', type: 'AUTHOR'},

    {name: 'Student Attendee/Local', amount: 6000, short_code: 'BDT', type: 'ATTENDEE'},
    {name: 'Student Attendee/SAARC Country', amount: 140, short_code: 'USD', type: 'ATTENDEE'},
    {name: 'Student Attendee/Other Countries',amount: 170, short_code: 'USD', type: 'ATTENDEE'},
]


export const tk_lists=[
    {name: 'General Author/Local', amount: 9500, short_code: 'BDT', type: 'AUTHOR'},
    {name: 'General Author/Local/ IEEE Member', amount: 8500, short_code: 'BDT', type: 'AUTHOR'},
    {name: 'General Author/SAARC Country', amount: 165, short_code: 'USD', type: 'AUTHOR'},
    {name: 'General Author/SAARC Country/IEEE Member', amount: 150, short_code: 'USD', type: 'AUTHOR'},
    {name: 'General Author/Other Countries',amount: 215, short_code: 'USD', type: 'AUTHOR'},
    {name: 'General Author/Other Countries/IEEE Member',amount: 180, short_code: 'USD', type: 'AUTHOR'},

    {name: 'General Attendee/Local', amount: 7500, short_code: 'BDT', type: 'ATTENDEE'},
    {name: 'General Attendee/SAARC Country', amount: 130, short_code: 'USD', type: 'ATTENDEE'},
    {name: 'General Attendee/Other Countries',amount: 160, short_code: 'USD', type: 'ATTENDEE'},

    {name: 'Student  Author/Local', amount: 6500, short_code: 'BDT', type: 'AUTHOR'},
    {name: 'Student  Author/Local/ IEEE Member', amount: 6000, short_code: 'BDT', type: 'AUTHOR'},
    {name: 'Student  Author/SAARC Country', amount: 150, short_code: 'USD', type: 'AUTHOR'},
    {name: 'Student  Author/SAARC Country/IEEE Member', amount: 120, short_code: 'USD', type: 'AUTHOR'},
    {name: 'Student  Author/Other Countries',amount: 180, short_code: 'USD', type: 'AUTHOR'},
    {name: 'Student  Author/Other Countries/IEEE Member',amount: 165, short_code: 'USD', type: 'AUTHOR'},

    {name: 'Student Attendee/Local', amount: 5500, short_code: 'BDT', type: 'ATTENDEE'},
    {name: 'Student Attendee/SAARC Country', amount: 130, short_code: 'USD', type: 'ATTENDEE'},
    {name: 'Student Attendee/Other Countries',amount: 160, short_code: 'USD', type: 'ATTENDEE'},

    {name: 'General Author/Local for Poster', amount: 7500, short_code: 'BDT', type: 'Poster'},
    {name: 'General Author/Local/ IEEE Member for Poster ', amount: 6500, short_code: 'BDT', type: 'Poster'},
    {name: 'General Author/SAARC Country for Poster', amount: 140, short_code: 'USD', type: 'Poster'},
    {name: 'General Author/SAARC Country/IEEE Member for Poster', amount: 125, short_code: 'USD', type: 'Poster'},
    {name: 'General Author/Other Countries for Poster',amount: 175, short_code: 'USD', type: 'Poster'},
    {name: 'General Author/Other Countries/IEEE Member for Poster',amount: 155, short_code: 'USD', type: 'Poster'},

    {name: 'Student  Author/Local for Poster', amount: 5500, short_code: 'BDT', type: 'Poster'},
    {name: 'Student  Author/Local/ IEEE Member for Poster', amount: 5000, short_code: 'BDT', type: 'Poster'},
    {name: 'Student  Author/SAARC Country for Poster', amount: 140, short_code: 'USD', type: 'Poster'},
    {name: 'Student  Author/SAARC Country/IEEE Member for Poster', amount: 110, short_code: 'USD', type: 'Poster'},
    {name: 'Student  Author/Other Countries for Poster',amount: 170, short_code: 'USD', type: 'Poster'},
    {name: 'Student  Author/Other Countries/IEEE Member for Poster',amount: 155, short_code: 'USD', type: 'Poster'},

]


export const countriesData=[
  {
    "value": "Afghanistan",
    "label": "Afghanistan"
  },
  {
    "value": "Åland Islands",
    "label": "Åland Islands"
  },
  {
    "value": "Albania",
    "label": "Albania"
  },
  {
    "value": "Algeria",
    "label": "Algeria"
  },
  {
    "value": "American Samoa",
    "label": "American Samoa"
  },
  {
    "value": "Andorra",
    "label": "Andorra"
  },
  {
    "value": "Angola",
    "label": "Angola"
  },
  {
    "value": "Anguilla",
    "label": "Anguilla"
  },
  {
    "value": "Antarctica",
    "label": "Antarctica"
  },
  {
    "value": "Antigua and Barbuda",
    "label": "Antigua and Barbuda"
  },
  {
    "value": "Argentina",
    "label": "Argentina"
  },
  {
    "value": "Armenia",
    "label": "Armenia"
  },
  {
    "value": "Aruba",
    "label": "Aruba"
  },
  {
    "value": "Australia",
    "label": "Australia"
  },
  {
    "value": "Austria",
    "label": "Austria"
  },
  {
    "value": "Azerbaijan",
    "label": "Azerbaijan"
  },
  {
    "value": "Bahamas",
    "label": "Bahamas"
  },
  {
    "value": "Bahrain",
    "label": "Bahrain"
  },
  {
    "value": "Bangladesh",
    "label": "Bangladesh"
  },
  {
    "value": "Barbados",
    "label": "Barbados"
  },
  {
    "value": "Belarus",
    "label": "Belarus"
  },
  {
    "value": "Belgium",
    "label": "Belgium"
  },
  {
    "value": "Belize",
    "label": "Belize"
  },
  {
    "value": "Benin",
    "label": "Benin"
  },
  {
    "value": "Bermuda",
    "label": "Bermuda"
  },
  {
    "value": "Bhutan",
    "label": "Bhutan"
  },
  {
    "value": "Bolivia",
    "label": "Bolivia"
  },
  {
    "value": "Bosnia and Herzegovina",
    "label": "Bosnia and Herzegovina"
  },
  {
    "value": "Botswana",
    "label": "Botswana"
  },
  {
    "value": "Bouvet Island",
    "label": "Bouvet Island"
  },
  {
    "value": "Brazil",
    "label": "Brazil"
  },
  {
    "value": "British Indian Ocean Territory",
    "label": "British Indian Ocean Territory"
  },
  {
    "value": "British Virgin Islands",
    "label": "British Virgin Islands"
  },
  {
    "value": "Brunei",
    "label": "Brunei"
  },
  {
    "value": "Bulgaria",
    "label": "Bulgaria"
  },
  {
    "value": "Burkina Faso",
    "label": "Burkina Faso"
  },
  {
    "value": "Burundi",
    "label": "Burundi"
  },
  {
    "value": "Cambodia",
    "label": "Cambodia"
  },
  {
    "value": "Cameroon",
    "label": "Cameroon"
  },
  {
    "value": "Canada",
    "label": "Canada"
  },
  {
    "value": "Cape Verde",
    "label": "Cape Verde"
  },
  {
    "value": "Caribbean Netherlands",
    "label": "Caribbean Netherlands"
  },
  {
    "value": "Cayman Islands",
    "label": "Cayman Islands"
  },
  {
    "value": "Central African Republic",
    "label": "Central African Republic"
  },
  {
    "value": "Chad",
    "label": "Chad"
  },
  {
    "value": "Chile",
    "label": "Chile"
  },
  {
    "value": "China",
    "label": "China"
  },
  {
    "value": "Christmas Island",
    "label": "Christmas Island"
  },
  {
    "value": "Cocos (Keeling) Islands",
    "label": "Cocos (Keeling) Islands"
  },
  {
    "value": "Colombia",
    "label": "Colombia"
  },
  {
    "value": "Comoros",
    "label": "Comoros"
  },
  {
    "value": "Cook Islands",
    "label": "Cook Islands"
  },
  {
    "value": "Costa Rica",
    "label": "Costa Rica"
  },
  {
    "value": "Croatia",
    "label": "Croatia"
  },
  {
    "value": "Cuba",
    "label": "Cuba"
  },
  {
    "value": "Curaçao",
    "label": "Curaçao"
  },
  {
    "value": "Cyprus",
    "label": "Cyprus"
  },
  {
    "value": "Czechia",
    "label": "Czechia"
  },
  {
    "value": "Denmark",
    "label": "Denmark"
  },
  {
    "value": "Djibouti",
    "label": "Djibouti"
  },
  {
    "value": "Dominica",
    "label": "Dominica"
  },
  {
    "value": "Dominican Republic",
    "label": "Dominican Republic"
  },
  {
    "value": "DR Congo",
    "label": "DR Congo"
  },
  {
    "value": "Ecuador",
    "label": "Ecuador"
  },
  {
    "value": "Egypt",
    "label": "Egypt"
  },
  {
    "value": "El Salvador",
    "label": "El Salvador"
  },
  {
    "value": "Equatorial Guinea",
    "label": "Equatorial Guinea"
  },
  {
    "value": "Eritrea",
    "label": "Eritrea"
  },
  {
    "value": "Estonia",
    "label": "Estonia"
  },
  {
    "value": "Eswatini",
    "label": "Eswatini"
  },
  {
    "value": "Ethiopia",
    "label": "Ethiopia"
  },
  {
    "value": "Falkland Islands",
    "label": "Falkland Islands"
  },
  {
    "value": "Faroe Islands",
    "label": "Faroe Islands"
  },
  {
    "value": "Fiji",
    "label": "Fiji"
  },
  {
    "value": "Finland",
    "label": "Finland"
  },
  {
    "value": "France",
    "label": "France"
  },
  {
    "value": "French Guiana",
    "label": "French Guiana"
  },
  {
    "value": "French Polynesia",
    "label": "French Polynesia"
  },
  {
    "value": "French Southern and Antarctic Lands",
    "label": "French Southern and Antarctic Lands"
  },
  {
    "value": "Gabon",
    "label": "Gabon"
  },
  {
    "value": "Gambia",
    "label": "Gambia"
  },
  {
    "value": "Georgia",
    "label": "Georgia"
  },
  {
    "value": "Germany",
    "label": "Germany"
  },
  {
    "value": "Ghana",
    "label": "Ghana"
  },
  {
    "value": "Gibraltar",
    "label": "Gibraltar"
  },
  {
    "value": "Greece",
    "label": "Greece"
  },
  {
    "value": "Greenland",
    "label": "Greenland"
  },
  {
    "value": "Grenada",
    "label": "Grenada"
  },
  {
    "value": "Guadeloupe",
    "label": "Guadeloupe"
  },
  {
    "value": "Guam",
    "label": "Guam"
  },
  {
    "value": "Guatemala",
    "label": "Guatemala"
  },
  {
    "value": "Guernsey",
    "label": "Guernsey"
  },
  {
    "value": "Guinea",
    "label": "Guinea"
  },
  {
    "value": "Guinea-Bissau",
    "label": "Guinea-Bissau"
  },
  {
    "value": "Guyana",
    "label": "Guyana"
  },
  {
    "value": "Haiti",
    "label": "Haiti"
  },
  {
    "value": "Heard Island and McDonald Islands",
    "label": "Heard Island and McDonald Islands"
  },
  {
    "value": "Honduras",
    "label": "Honduras"
  },
  {
    "value": "Hong Kong",
    "label": "Hong Kong"
  },
  {
    "value": "Hungary",
    "label": "Hungary"
  },
  {
    "value": "Iceland",
    "label": "Iceland"
  },
  {
    "value": "India",
    "label": "India"
  },
  {
    "value": "Indonesia",
    "label": "Indonesia"
  },
  {
    "value": "Iran",
    "label": "Iran"
  },
  {
    "value": "Iraq",
    "label": "Iraq"
  },
  {
    "value": "Ireland",
    "label": "Ireland"
  },
  {
    "value": "Isle of Man",
    "label": "Isle of Man"
  },
  {
    "value": "Israel",
    "label": "Israel"
  },
  {
    "value": "Italy",
    "label": "Italy"
  },
  {
    "value": "Ivory Coast",
    "label": "Ivory Coast"
  },
  {
    "value": "Jamaica",
    "label": "Jamaica"
  },
  {
    "value": "Japan",
    "label": "Japan"
  },
  {
    "value": "Jersey",
    "label": "Jersey"
  },
  {
    "value": "Jordan",
    "label": "Jordan"
  },
  {
    "value": "Kazakhstan",
    "label": "Kazakhstan"
  },
  {
    "value": "Kenya",
    "label": "Kenya"
  },
  {
    "value": "Kiribati",
    "label": "Kiribati"
  },
  {
    "value": "Kosovo",
    "label": "Kosovo"
  },
  {
    "value": "Kuwait",
    "label": "Kuwait"
  },
  {
    "value": "Kyrgyzstan",
    "label": "Kyrgyzstan"
  },
  {
    "value": "Laos",
    "label": "Laos"
  },
  {
    "value": "Latvia",
    "label": "Latvia"
  },
  {
    "value": "Lebanon",
    "label": "Lebanon"
  },
  {
    "value": "Lesotho",
    "label": "Lesotho"
  },
  {
    "value": "Liberia",
    "label": "Liberia"
  },
  {
    "value": "Libya",
    "label": "Libya"
  },
  {
    "value": "Liechtenstein",
    "label": "Liechtenstein"
  },
  {
    "value": "Lithuania",
    "label": "Lithuania"
  },
  {
    "value": "Luxembourg",
    "label": "Luxembourg"
  },
  {
    "value": "Macau",
    "label": "Macau"
  },
  {
    "value": "Madagascar",
    "label": "Madagascar"
  },
  {
    "value": "Malawi",
    "label": "Malawi"
  },
  {
    "value": "Malaysia",
    "label": "Malaysia"
  },
  {
    "value": "Maldives",
    "label": "Maldives"
  },
  {
    "value": "Mali",
    "label": "Mali"
  },
  {
    "value": "Malta",
    "label": "Malta"
  },
  {
    "value": "Marshall Islands",
    "label": "Marshall Islands"
  },
  {
    "value": "Martinique",
    "label": "Martinique"
  },
  {
    "value": "Mauritania",
    "label": "Mauritania"
  },
  {
    "value": "Mauritius",
    "label": "Mauritius"
  },
  {
    "value": "Mayotte",
    "label": "Mayotte"
  },
  {
    "value": "Mexico",
    "label": "Mexico"
  },
  {
    "value": "Micronesia",
    "label": "Micronesia"
  },
  {
    "value": "Moldova",
    "label": "Moldova"
  },
  {
    "value": "Monaco",
    "label": "Monaco"
  },
  {
    "value": "Mongolia",
    "label": "Mongolia"
  },
  {
    "value": "Montenegro",
    "label": "Montenegro"
  },
  {
    "value": "Montserrat",
    "label": "Montserrat"
  },
  {
    "value": "Morocco",
    "label": "Morocco"
  },
  {
    "value": "Mozambique",
    "label": "Mozambique"
  },
  {
    "value": "Myanmar",
    "label": "Myanmar"
  },
  {
    "value": "Namibia",
    "label": "Namibia"
  },
  {
    "value": "Nauru",
    "label": "Nauru"
  },
  {
    "value": "Nepal",
    "label": "Nepal"
  },
  {
    "value": "Netherlands",
    "label": "Netherlands"
  },
  {
    "value": "New Caledonia",
    "label": "New Caledonia"
  },
  {
    "value": "New Zealand",
    "label": "New Zealand"
  },
  {
    "value": "Nicaragua",
    "label": "Nicaragua"
  },
  {
    "value": "Niger",
    "label": "Niger"
  },
  {
    "value": "Nigeria",
    "label": "Nigeria"
  },
  {
    "value": "Niue",
    "label": "Niue"
  },
  {
    "value": "Norfolk Island",
    "label": "Norfolk Island"
  },
  {
    "value": "North Korea",
    "label": "North Korea"
  },
  {
    "value": "North Macedonia",
    "label": "North Macedonia"
  },
  {
    "value": "Northern Mariana Islands",
    "label": "Northern Mariana Islands"
  },
  {
    "value": "Norway",
    "label": "Norway"
  },
  {
    "value": "Oman",
    "label": "Oman"
  },
  {
    "value": "Pakistan",
    "label": "Pakistan"
  },
  {
    "value": "Palau",
    "label": "Palau"
  },
  {
    "value": "Palestine",
    "label": "Palestine"
  },
  {
    "value": "Panama",
    "label": "Panama"
  },
  {
    "value": "Papua New Guinea",
    "label": "Papua New Guinea"
  },
  {
    "value": "Paraguay",
    "label": "Paraguay"
  },
  {
    "value": "Peru",
    "label": "Peru"
  },
  {
    "value": "Philippines",
    "label": "Philippines"
  },
  {
    "value": "Pitcairn Islands",
    "label": "Pitcairn Islands"
  },
  {
    "value": "Poland",
    "label": "Poland"
  },
  {
    "value": "Portugal",
    "label": "Portugal"
  },
  {
    "value": "Puerto Rico",
    "label": "Puerto Rico"
  },
  {
    "value": "Qatar",
    "label": "Qatar"
  },
  {
    "value": "Republic of the Congo",
    "label": "Republic of the Congo"
  },
  {
    "value": "Réunion",
    "label": "Réunion"
  },
  {
    "value": "Romania",
    "label": "Romania"
  },
  {
    "value": "Russia",
    "label": "Russia"
  },
  {
    "value": "Rwanda",
    "label": "Rwanda"
  },
  {
    "value": "Saint Barthélemy",
    "label": "Saint Barthélemy"
  },
  {
    "value": "Saint Helena, Ascension and Tristan da Cunha",
    "label": "Saint Helena, Ascension and Tristan da Cunha"
  },
  {
    "value": "Saint Kitts and Nevis",
    "label": "Saint Kitts and Nevis"
  },
  {
    "value": "Saint Lucia",
    "label": "Saint Lucia"
  },
  {
    "value": "Saint Martin",
    "label": "Saint Martin"
  },
  {
    "value": "Saint Pierre and Miquelon",
    "label": "Saint Pierre and Miquelon"
  },
  {
    "value": "Saint Vincent and the Grenadines",
    "label": "Saint Vincent and the Grenadines"
  },
  {
    "value": "Samoa",
    "label": "Samoa"
  },
  {
    "value": "San Marino",
    "label": "San Marino"
  },
  {
    "value": "São Tomé and Príncipe",
    "label": "São Tomé and Príncipe"
  },
  {
    "value": "Saudi Arabia",
    "label": "Saudi Arabia"
  },
  {
    "value": "Senegal",
    "label": "Senegal"
  },
  {
    "value": "Serbia",
    "label": "Serbia"
  },
  {
    "value": "Seychelles",
    "label": "Seychelles"
  },
  {
    "value": "Sierra Leone",
    "label": "Sierra Leone"
  },
  {
    "value": "Singapore",
    "label": "Singapore"
  },
  {
    "value": "Sint Maarten",
    "label": "Sint Maarten"
  },
  {
    "value": "Slovakia",
    "label": "Slovakia"
  },
  {
    "value": "Slovenia",
    "label": "Slovenia"
  },
  {
    "value": "Solomon Islands",
    "label": "Solomon Islands"
  },
  {
    "value": "Somalia",
    "label": "Somalia"
  },
  {
    "value": "South Africa",
    "label": "South Africa"
  },
  {
    "value": "South Georgia",
    "label": "South Georgia"
  },
  {
    "value": "South Korea",
    "label": "South Korea"
  },
  {
    "value": "South Sudan",
    "label": "South Sudan"
  },
  {
    "value": "Spain",
    "label": "Spain"
  },
  {
    "value": "Sri Lanka",
    "label": "Sri Lanka"
  },
  {
    "value": "Sudan",
    "label": "Sudan"
  },
  {
    "value": "Suriname",
    "label": "Suriname"
  },
  {
    "value": "Svalbard and Jan Mayen",
    "label": "Svalbard and Jan Mayen"
  },
  {
    "value": "Sweden",
    "label": "Sweden"
  },
  {
    "value": "Switzerland",
    "label": "Switzerland"
  },
  {
    "value": "Syria",
    "label": "Syria"
  },
  {
    "value": "Taiwan",
    "label": "Taiwan"
  },
  {
    "value": "Tajikistan",
    "label": "Tajikistan"
  },
  {
    "value": "Tanzania",
    "label": "Tanzania"
  },
  {
    "value": "Thailand",
    "label": "Thailand"
  },
  {
    "value": "Timor-Leste",
    "label": "Timor-Leste"
  },
  {
    "value": "Togo",
    "label": "Togo"
  },
  {
    "value": "Tokelau",
    "label": "Tokelau"
  },
  {
    "value": "Tonga",
    "label": "Tonga"
  },
  {
    "value": "Trinidad and Tobago",
    "label": "Trinidad and Tobago"
  },
  {
    "value": "Tunisia",
    "label": "Tunisia"
  },
  {
    "value": "Turkey",
    "label": "Turkey"
  },
  {
    "value": "Turkmenistan",
    "label": "Turkmenistan"
  },
  {
    "value": "Turks and Caicos Islands",
    "label": "Turks and Caicos Islands"
  },
  {
    "value": "Tuvalu",
    "label": "Tuvalu"
  },
  {
    "value": "Uganda",
    "label": "Uganda"
  },
  {
    "value": "Ukraine",
    "label": "Ukraine"
  },
  {
    "value": "United Arab Emirates",
    "label": "United Arab Emirates"
  },
  {
    "value": "United Kingdom",
    "label": "United Kingdom"
  },
  {
    "value": "United States",
    "label": "United States"
  },
  {
    "value": "United States Minor Outlying Islands",
    "label": "United States Minor Outlying Islands"
  },
  {
    "value": "United States Virgin Islands",
    "label": "United States Virgin Islands"
  },
  {
    "value": "Uruguay",
    "label": "Uruguay"
  },
  {
    "value": "Uzbekistan",
    "label": "Uzbekistan"
  },
  {
    "value": "Vanuatu",
    "label": "Vanuatu"
  },
  {
    "value": "Vatican City",
    "label": "Vatican City"
  },
  {
    "value": "Venezuela",
    "label": "Venezuela"
  },
  {
    "value": "Vietnam",
    "label": "Vietnam"
  },
  {
    "value": "Wallis and Futuna",
    "label": "Wallis and Futuna"
  },
  {
    "value": "Western Sahara",
    "label": "Western Sahara"
  },
  {
    "value": "Yemen",
    "label": "Yemen"
  },
  {
    "value": "Zambia",
    "label": "Zambia"
  },
  {
    "value": "Zimbabwe",
    "label": "Zimbabwe"
  }
]

export const paperData=[
  {
    "id": 1,
    "PaperID": 20,
    "Title": "Smart Agriculture Automation Using Embedded Systems: A Cost-Effective Approach to Precision Farming"
  },
  {
    "id": 2,
    "PaperID": 24,
    "Title": "Development of an optimal lightweight block cipher to secure MIoT in Telemedicine Network."
  },
  {
    "id": 3,
    "PaperID": 26,
    "Title": "MediBox: An IoT based smart medicine dispenser for optimal healthcare with mobile application assistance and security system"
  },
  {
    "id": 4,
    "PaperID": 30,
    "Title": "Comparative Analysis of Kapton Polyimide and Copper Based Antenna for Breast Tumor Detection"
  },
  {
    "id": 5,
    "PaperID": 32,
    "Title": "Optimizing Workforce Productivity with TrackMee: An Online Resource Management System"
  },
  {
    "id": 6,
    "PaperID": 33,
    "Title": "Enhancing Automated Medical Question-Answer Systems Using Fine-Tuned Large Language Models"
  },
  {
    "id": 7,
    "PaperID": 37,
    "Title": "The Impact of Smoking and Alcohol Consumption on University Students' Psychological Wellness with Machine Learning Approach"
  },
  {
    "id": 8,
    "PaperID": 44,
    "Title": "Multi-Agent Battlefield Game with Federated Reinforcement Learning"
  },
  {
    "id": 9,
    "PaperID": 47,
    "Title": "SondhiNet: A CNN-Classifiers Framework for Enhanced Bangla Handwritten Character Recognition with Ensemble Integration"
  },
  {
    "id": 10,
    "PaperID": 51,
    "Title": "Ocean Fish Classification using pre-train CNN models and Performance Evaluation: A robust machine learning approach."
  },
  {
    "id": 11,
    "PaperID": 52,
    "Title": "WhatsApp Based Smart Home Automation System"
  },
  {
    "id": 12,
    "PaperID": 54,
    "Title": "Intelligent residence surveyor: mesh technology for energy surveillance and management framework using MQTT network protocol"
  },
  {
    "id": 13,
    "PaperID": 65,
    "Title": "Advancing Bangla Sign Language Recognition Through Deep Learning Techniques"
  },
  {
    "id": 14,
    "PaperID": 67,
    "Title": "Deep Learning Model for Electrical Load Forecasting Considering Meteorological Effect"
  },
  {
    "id": 15,
    "PaperID": 71,
    "Title": "Leveraging Hyperledger Besu-Based Private Blockchain, IPFS, and NFTs for Secure and Transparent Intellectual Property Preservation and Trading"
  },
  {
    "id": 16,
    "PaperID": 73,
    "Title": "Multi-Class Cyberbullying Analysis in Bengali: A Comparative Study of BERT-Based Deep Learning Models"
  },
  {
    "id": 17,
    "PaperID": 75,
    "Title": "Design And Implementation of An IoT Based Smart Syringe Infusion Pump Prototype for Enhanced Healthcare Support"
  },
  {
    "id": 18,
    "PaperID": 76,
    "Title": "SSHAD: Self-Supervised Hybrid Model for Anomaly Detection in Graphs"
  },
  {
    "id": 19,
    "PaperID": 77,
    "Title": "Weighted Gradient-Forest Imputer: Explainable and Scalable Missing Value Imputation for Workforce Analytics"
  },
  {
    "id": 20,
    "PaperID": 78,
    "Title": "Design and Analysis of a Single-Core PCF-based SPR Biosensor for Sensitivity Improvement in Skin and Blood Cancer Detection"
  },
  {
    "id": 21,
    "PaperID": 81,
    "Title": "PawsTrack: An Advanced IoT-Driven Solution for Enhanced Pet Safety with Environmental Monitoring and Smart Connectivity"
  },
  {
    "id": 22,
    "PaperID": 83,
    "Title": "Design and Performance Analysis of a Metamaterial-Based Dielectric Resonator MIMO Antenna for K-Band Applications"
  },
  {
    "id": 23,
    "PaperID": 87,
    "Title": "Design and Analysis of a C-Band Quadrifilar Helical Antenna for Radar Applications"
  },
  {
    "id": 24,
    "PaperID": 88,
    "Title": "A Lightweight Ensemble Network for Brain Tumor Detection from MRI Images"
  },
  {
    "id": 25,
    "PaperID": 95,
    "Title": "CricBakko: A New Bangla Dataset on Bangladesh Cricket for Sentiment Analysis"
  },
  {
    "id": 26,
    "PaperID": 108,
    "Title": "Simulation Study of Microstrip Patch Antenna with a Trident-shaped Slot for 5G Applications"
  },
  {
    "id": 27,
    "PaperID": 123,
    "Title": "Symmetrical Geometric-Shaped Metamaterial Absorber for Different Water-sensing Applications at 5.7 GHz"
  },
  {
    "id": 28,
    "PaperID": 124,
    "Title": "Design and Performance Analysis of Rectangular Microstrip Patch Antenna For 5G Applications"
  },
  {
    "id": 29,
    "PaperID": 128,
    "Title": "Automated Segmentation and Detection of Rice Blast Disease Using U-Net and Image Processing"
  },
  {
    "id": 30,
    "PaperID": 129,
    "Title": "IntruDetect: A Hybrid Deep Learning Approach for Intrusion Detection in Network Security"
  },
  {
    "id": 31,
    "PaperID": 135,
    "Title": "Satellite Image Segmentation Based on Improved Lightweight U-Net"
  },
  {
    "id": 32,
    "PaperID": 140,
    "Title": "Boomerang: Automated Threat Detection and Incident Response Framework for Virtual Machines in Cloud Environments"
  },
  {
    "id": 33,
    "PaperID": 145,
    "Title": "IoT-enabled Automatic Underground Cable Fault Detection and Monitoring System"
  },
  {
    "id": 34,
    "PaperID": 146,
    "Title": "Energy Management in Grid-tied Rooftop PV Systems Using PSO and ANN-based Control Schemes"
  },
  {
    "id": 35,
    "PaperID": 147,
    "Title": "Speech Emotion Recognition using Branched-based Convolutional Neural Network Technique"
  },
  {
    "id": 36,
    "PaperID": 152,
    "Title": "Preserving Ownership and Trading of AI Prompts in Decentralized Manner via Hyperledger Besu-Based Blockchain and IPFS-Backed NFTs"
  },
  {
    "id": 37,
    "PaperID": 157,
    "Title": "An Intelligent Model Based on Data Mining and Machine Learning Approaches for Diagnosing Hepatitis Disease"
  },
  {
    "id": 38,
    "PaperID": 158,
    "Title": "A Machine Learning Based Expert System for The Diagnosis of Cardiovascular Diseases"
  },
  {
    "id": 39,
    "PaperID": 160,
    "Title": "Multi-Stage Alzheimer’s Disease Prediction Using Multihead Attention based CNN-BiGRU with XAI"
  },
  {
    "id": 40,
    "PaperID": 166,
    "Title": "Exploring Two-Stage Multi-Class Pneumonia Prediction from x-ray Images with Lightweight Feature Extraction Model"
  },
  {
    "id": 41,
    "PaperID": 168,
    "Title": "AIS-140 NavIC based Vehicle Tracking System with 4G GPRS"
  },
  {
    "id": 42,
    "PaperID": 169,
    "Title": "Analysis of Deep Learning Models for Predicting the Effects of anti-VEGF Drugs on Ovarian Cancer from Histopathology Images"
  },
  {
    "id": 43,
    "PaperID": 172,
    "Title": "Enhanced Stress Detection via Heart Rate Data: A Feature Selection and Stacking Ensemble Approach"
  },
  {
    "id": 44,
    "PaperID": 175,
    "Title": "Enhanced Cardiovascular Disease Prediction: A Comparative Analysis of Machine Learning Models with SMOTE Balancing"
  },
  {
    "id": 45,
    "PaperID": 180,
    "Title": "Performance Insights on NOMA-Massive MIMO Systems in Nakagami-m Fading Environments"
  },
  {
    "id": 46,
    "PaperID": 187,
    "Title": "Shapley Additive exPlanations for Identification of Astrocytoma and Glioblastoma using Region-Based MRI Radiomics Feature Analysis"
  },
  {
    "id": 47,
    "PaperID": 188,
    "Title": "Lane Detection Using Orthogonal Wavelet Transform and Polynomial Line Fitting"
  },
  {
    "id": 48,
    "PaperID": 193,
    "Title": "WBFVD: A UNet-Based Deep Learning Model for True-to-Color Image Colorization of White-Background Fruits & Vegetables Dataset"
  },
  {
    "id": 49,
    "PaperID": 203,
    "Title": "Optimizing EEG Channel Selection for Alzheimer’s Disease Classification: A Regional Brain Analysis"
  },
  {
    "id": 50,
    "PaperID": 211,
    "Title": "Machine Learning Approach for Efficient Radar Target Classification"
  },
  {
    "id": 51,
    "PaperID": 214,
    "Title": "Chaos-Based Synchronous Nonce Generation for Enhancing ATM Card Transaction Security"
  },
  {
    "id": 52,
    "PaperID": 215,
    "Title": "Hybrid Deep Learning Approach for Accurate Grape Leaf Disease Segmentation and Classification"
  },
  {
    "id": 53,
    "PaperID": 216,
    "Title": "MetaTradeNet: A Meta-Learning Framework for Adaptive Algorithmic Trading"
  },
  {
    "id": 54,
    "PaperID": 218,
    "Title": "Design & Performance Analysis of mmWave FMCW MIMO Radar Antenna"
  },
  {
    "id": 55,
    "PaperID": 220,
    "Title": "A Hybrid Framework Combining GAN-Based Augmentation and Ensemble Learning for Improved Satellite Image Classification"
  },
  {
    "id": 56,
    "PaperID": 221,
    "Title": "Exploration of an E-waste Prediction Model for Collection System Optimization Using Deep Learning Models in E-waste Management Facilities"
  },
  {
    "id": 57,
    "PaperID": 224,
    "Title": "MRANet: A Modified Residual Attention Networks for Lung and Colon Cancer Classification"
  },
  {
    "id": 58,
    "PaperID": 239,
    "Title": "A Hybrid Deep Learning Approach with Explainable AI for Bangladeshi Birds Classification"
  },
  {
    "id": 59,
    "PaperID": 249,
    "Title": "Optimizing Breast Cancer Diagnosis with VGG16 and CNN: An XAI Approach Using Saliency Maps"
  },
  {
    "id": 60,
    "PaperID": 250,
    "Title": "SSChNet: Self Supervised Learning based pre-trained network for Child Speech Recognition"
  },
  {
    "id": 61,
    "PaperID": 258,
    "Title": "Visual Speech Recognition in Bangla : A Convolutional LSTM Framework"
  },
  {
    "id": 62,
    "PaperID": 261,
    "Title": "Performance Comparison of CycleGAN for Image-to-Image Translation in Multiple Domains"
  },
  {
    "id": 63,
    "PaperID": 262,
    "Title": "Self-Improving Emoji Prediction: A Transformer-Based CNN-BiLSTM Model with Feedback Learning"
  },
  {
    "id": 64,
    "PaperID": 263,
    "Title": "A Hybrid Deep Learning Approach for Dialect Specific Sentiment Analysis of Bangla Regional Linguistics"
  },
  {
    "id": 65,
    "PaperID": 265,
    "Title": "Brain Tumor Classification Using Artificial Neural Networks with LBP and PCA for Feature Optimization"
  },
  {
    "id": 66,
    "PaperID": 271,
    "Title": "Prediction of Youth Political Involvement in Bangladesh through Social Media: A Machine Learning Perspective"
  },
  {
    "id": 67,
    "PaperID": 274,
    "Title": "Advancing Deepfake Detection: A Optimized Neural Network Model with Keyframe Analysis"
  },
  {
    "id": 68,
    "PaperID": 276,
    "Title": "Predictive Model for Asthma Diagnosis Using Advanced Feature Selection and Voting Techniques with Model Explainability"
  },
  {
    "id": 69,
    "PaperID": 279,
    "Title": "Sustainable Water Quality Monitoring for Efficient Industrial Water Management"
  },
  {
    "id": 70,
    "PaperID": 284,
    "Title": "CutShort Hybrid Sorting Technique for Strings: A Comparative Analysis with Parallel Enhancements"
  },
  {
    "id": 71,
    "PaperID": 292,
    "Title": "Lightweight Vision Transformer Network for Diabetic Retinopathy Classification Through Data Balancing Approach"
  },
  {
    "id": 72,
    "PaperID": 296,
    "Title": "Privacy and Security Threats of Recommendation Systems: Awareness and Perspective of Users of Bangladesh"
  },
  {
    "id": 73,
    "PaperID": 297,
    "Title": "Skin Cancer Classification Using Pre-trained CNNs: A Transfer Learning Approach Addressing Imbalanced Data Challenges"
  },
  {
    "id": 74,
    "PaperID": 298,
    "Title": "AI-Driven Breast Cancer Detection: Leveraging Transfer Learning for Enhanced Radiographic Analysis"
  },
  {
    "id": 75,
    "PaperID": 301,
    "Title": "Enhancing Hate Speech Detection in Bengali Language Using Machine Learning and Deep Learning Algorithms"
  },
  {
    "id": 76,
    "PaperID": 304,
    "Title": "A Comparative Study: Leveraging BERT and K-fold Cross Validation for UPOS Tagging in Bengali"
  },
  {
    "id": 77,
    "PaperID": 305,
    "Title": "A Hybrid Clustering and Classification Approach for Mental Health Diagnosis in Rohingya Refugees Using Explainable AI: SHAP and LIME."
  },
  {
    "id": 78,
    "PaperID": 309,
    "Title": "Parallel ANN Model: A Potential Alternative to CNNs for Network Intrusion Detection on the UNSW-NB15 Dataset"
  },
  {
    "id": 79,
    "PaperID": 312,
    "Title": "Machine Learning Based Optimization of Multiband LPDA Antenna for Wireless Applications"
  },
  {
    "id": 80,
    "PaperID": 315,
    "Title": "MaskNet: Enhancing Crime Event Detection with Feature Masking and Dynamic Attention"
  },
  {
    "id": 81,
    "PaperID": 316,
    "Title": "Performance Optimization of Hybrid Beamforming in MU-MIMO NOMA Systems with Reconfigurable Intelligent Surfaces"
  },
  {
    "id": 82,
    "PaperID": 318,
    "Title": "AI Driven Intelligent Transport System for Enhancing Road Safety in Bangladesh"
  },
  {
    "id": 83,
    "PaperID": 321,
    "Title": "Blockchain-Based Interoperable Healthcare System for Secure and Unified Patient Records Management"
  },
  {
    "id": 84,
    "PaperID": 323,
    "Title": "Feature-Enhanced Rainfall Prediction in Bangladesh Using Statistical and Machine Learning Models Integrated with Explainable AI"
  },
  {
    "id": 85,
    "PaperID": 329,
    "Title": "Hybrid Email Filtering Using TF-IDF and BERT Enhanced Spam Detector (TBESD)"
  },
  {
    "id": 86,
    "PaperID": 331,
    "Title": "Concentric Ring-Based Compact Metamaterial Absorber for C, X, Ku and K Band Applications"
  },
  {
    "id": 87,
    "PaperID": 339,
    "Title": "AECNet: Advancing Skin Cancer Classification using ACGAN-Based Synthetic Data with Grad-CAM Explainability"
  },
  {
    "id": 88,
    "PaperID": 346,
    "Title": "Compact Dual-Port MIMO Microstrip Patch Antenna for Terahertz Applications in 6G Communications"
  },
  {
    "id": 89,
    "PaperID": 347,
    "Title": "A Comparative Analysis on Different Feature Extraction Techniques for EEG-based Mental Workload Classification"
  },
  {
    "id": 90,
    "PaperID": 350,
    "Title": "AST-GCN: An Attention-Guided Spatial-Temporal GCN Framework for Gait Recognition"
  },
  {
    "id": 91,
    "PaperID": 357,
    "Title": "Evaluating Online Learning Effectiveness Using AHP-TOPSIS: A Comprehensive Analysis of Student Feedback"
  },
  {
    "id": 92,
    "PaperID": 365,
    "Title": "Weighted Densenet Ensemble with Transformer Encoder and External Attention for Gastrointestinal Disease Classification"
  },
  {
    "id": 93,
    "PaperID": 368,
    "Title": "Interpretable Heart Failure Identification Utilizing Auto Machine Learning Tools"
  },
  {
    "id": 94,
    "PaperID": 370,
    "Title": "Hepatitis C Detection from Blood Donor Data Using Hybrid Deep Feature Synthesis and Interpretable Machine Learning"
  },
  {
    "id": 95,
    "PaperID": 371,
    "Title": "Enhancing Wound Diagnosis with DoubleU-Net: An AI-Driven Segmentation Approach"
  },
  {
    "id": 96,
    "PaperID": 376,
    "Title": "A Comparative Evaluation of Machine Learning Approaches for Polycystic Ovary Syndrome Prediction with ANOVA-Based Feature Selection"
  },
  {
    "id": 97,
    "PaperID": 377,
    "Title": "HSTViT: A Hybrid Approach of Vision Transformers and Superimposing For Brain Stroke Classification and Lesion Area Quantification"
  },
  {
    "id": 98,
    "PaperID": 379,
    "Title": "Classifying Nutritional Deficiencies in Coffee leaf Using Transfer Learning and Gradient-Weighted Class Activation Mapping (Grad-CAM) Visualization"
  },
  {
    "id": 99,
    "PaperID": 380,
    "Title": "Evaluating Tea Leaf Quality with Deep Learning: Insights from Occlusion Sensitivity Analysis"
  },
  {
    "id": 100,
    "PaperID": 383,
    "Title": "Spatiotemporal NLP Modeling and Machine Learning for Predictive Rice Yield Analysis in Precision Farming"
  },
  {
    "id": 101,
    "PaperID": 388,
    "Title": "Real-Time EEG Dynamics in Females: A Comparative Analysis of Eyes-Open and Eyes-Closed Resting States"
  },
  {
    "id": 102,
    "PaperID": 398,
    "Title": "Implementation of IoT Based Poultry Farm Monitoring System with Real Time Data Analysis"
  },
  {
    "id": 103,
    "PaperID": 406,
    "Title": "ViT-SAGE: A Hybrid Vision Transformer based Architecture with Graph Neural Network Fusion for Precise Kidney Disease Classification"
  },
  {
    "id": 104,
    "PaperID": 408,
    "Title": "Cutting-Edge Deep Learning Architectures for Detecting and Classifying Phishing URLs"
  },
  {
    "id": 105,
    "PaperID": 413,
    "Title": "Identifying Bangla Political Hate Speech using Transformer-based Approach"
  },
  {
    "id": 106,
    "PaperID": 419,
    "Title": "Efficient-AgriNet: A Hybrid Deep Learning Model for Crops Disease Detection"
  },
  {
    "id": 107,
    "PaperID": 432,
    "Title": "Zero-Shot Face Recognition via Fine-Tuning CLIP with Contrastive Alignment"
  },
  {
    "id": 108,
    "PaperID": 433,
    "Title": "Multi-Scale Channel Attention with Dual Pooling and Dual Blocks for Gastrointestinal Abnormality Recognition in Endoscopic Images"
  },
  {
    "id": 109,
    "PaperID": 436,
    "Title": "An IoT-Integrated Autonomous Fire Extinguishing and Surveillance Robot Development Using Smart Camera Module"
  },
  {
    "id": 110,
    "PaperID": 443,
    "Title": "A Lightweight Framework for Facial Emotion Recognition: Leveraging Geometrical Priors with Spatial Features"
  },
  {
    "id": 111,
    "PaperID": 446,
    "Title": "A Multi-Stage Deep Learning Approach to Tuberculosis Detection with Explainable Insights"
  },
  {
    "id": 112,
    "PaperID": 448,
    "Title": "Real-Time Weed Detection Using Advanced Object Detection Models: A Comparative Study"
  },
  {
    "id": 113,
    "PaperID": 450,
    "Title": "Optimized Hybrid Cascaded Approach for Accurate Oral Cancer Detection in Histopathology Images Using Deep CNNs"
  },
  {
    "id": 114,
    "PaperID": 453,
    "Title": "TYMBERT: Tiny Yet Mighty– Fine-Tuned and Compressed TinyBERT for High-Accuracy, Low-Resource NLP"
  },
  {
    "id": 115,
    "PaperID": 468,
    "Title": "Adaptive Defense Against Packet-Mutation Adversarial Attacks in Network Intrusion Detection"
  },
  {
    "id": 116,
    "PaperID": 470,
    "Title": "Optimizing Deep Learning for Skin Cancer Classification: A Computationally Efficient CNN with Minimal Accuracy Trade-Off"
  },
  {
    "id": 117,
    "PaperID": 473,
    "Title": "Deep Learning for Skin Cancer Detection: Multi-Class Lesion Classification Using CNN Architectures"
  },
  {
    "id": 118,
    "PaperID": 477,
    "Title": "Optimizing Sign Language Classification: A Deep Learning Approach with Custom CNNs and Transfer Learning"
  },
  {
    "id": 119,
    "PaperID": 478,
    "Title": "Preeclampsia Prediction Using Machine Learning with Electronic Medical Records in Low-Resource Settings"
  },
  {
    "id": 120,
    "PaperID": 482,
    "Title": "An Explainable Ensemble Model for Credit Card Fraud Detection Using Advanced Data Balancing and Feature Selection Technique"
  },
  {
    "id": 121,
    "PaperID": 483,
    "Title": "FT-HELC: A Fine-tuned Hybrid Ensemble Technique for Lung Cancer Classification and Prediction Using a Clinical Dataset"
  },
  {
    "id": 122,
    "PaperID": 500,
    "Title": "Multilingual Sarcasm Detection Using Deep Learning and Transformed Based Model"
  },
  {
    "id": 123,
    "PaperID": 501,
    "Title": "Comprehensive Analysis of Control Techniques for BLDC Motor: Genetic Algorithm vs Fuzzy-PID"
  },
  {
    "id": 124,
    "PaperID": 503,
    "Title": "AI-Driven Prediction of Protein Structural Stability: A Machine Learning Approach for Accurate RMSD Estimation"
  },
  {
    "id": 125,
    "PaperID": 507,
    "Title": "Hybrid Feature Selection and Deep Learning Framework for Optimized Hyperspectral Image Analysis"
  },
  {
    "id": 126,
    "PaperID": 511,
    "Title": "Integrative Machine Learning Approach for the Early Detection of Motor Dysgraphia via Handwriting and EEG Signal Analysis"
  },
  {
    "id": 127,
    "PaperID": 512,
    "Title": "Automated Food Spoilage Detection Using Deep Learning: A CNN-Based Approach"
  },
  {
    "id": 128,
    "PaperID": 521,
    "Title": "AGNet: An Alternate Guidance Network for Colorectal Polyp Segmentation and Detection"
  },
  {
    "id": 129,
    "PaperID": 523,
    "Title": "Comprehensive Analysis and Forecasting of Maximum and Minimum Temperature Using Deep Learning Techniques"
  },
  {
    "id": 130,
    "PaperID": 524,
    "Title": "Distributed Intrusion Detection System For Edge of Things To Enhance Security"
  },
  {
    "id": 131,
    "PaperID": 526,
    "Title": "Bangla BERT for Hyperpartisan News Detection: A Semi-Supervised and Explainable AI Approach"
  },
  {
    "id": 132,
    "PaperID": 530,
    "Title": "Quantum Machine Learning for Image Classification: A Hybrid Model of Residual Network with Quantum Support Vector Machine"
  },
  {
    "id": 133,
    "PaperID": 531,
    "Title": "Quanvolutional Neural Networks for Pneumonia Detection: An Efficient Quantum-Assisted Feature Extraction Paradigm"
  },
  {
    "id": 134,
    "PaperID": 532,
    "Title": "Explainable Wafer Map Defect Classification Using Lightweight Data Augmentation and Convolutional Neural Network"
  },
  {
    "id": 135,
    "PaperID": 542,
    "Title": "Revolutionizing MRI Reconstruction from Compressed Sensing k-space measurements: An AI-Driven Feature Extraction Approach"
  },
  {
    "id": 136,
    "PaperID": 543,
    "Title": "Analyzing Bot Activity and Political Discourse in the 2024 U.S. Presidential Election: A Machine Learning Approach to Misinformation and Manipulation"
  },
  {
    "id": 137,
    "PaperID": 545,
    "Title": "Distinguishing Human-Written and AI-Generated Text: A Comprehensive Study Using Explainable Artificial Intelligence in Text Classification"
  },
  {
    "id": 138,
    "PaperID": 546,
    "Title": "Adaptability of ASR Models on Low-Resource Language: A Comparative Study of Whisper and Wav2Vec-BERT on Bangla"
  },
  {
    "id": 139,
    "PaperID": 557,
    "Title": "Performance Analysis of Optimization Techniques Implemented on the AVR System using MATLAB Simulink"
  },
  {
    "id": 140,
    "PaperID": 558,
    "Title": "Enhancing Robustness in Breast Lesion Segmentation with Perturbed Prompts for the Segment Anything Model"
  },
  {
    "id": 141,
    "PaperID": 565,
    "Title": "Multimodal Deep Learning Approach for Bangla Sign Language Recognition: Integrating Spatial and Geometric Features"
  },
  {
    "id": 142,
    "PaperID": 570,
    "Title": "Evaluation of Multi-RIS Assisted Indoor Channels at 73 and 142 GHz Frequency Bands"
  },
  {
    "id": 143,
    "PaperID": 572,
    "Title": "Real-Time AQI Estimation: A Smart and Lightweight AI-Based System Using Gas Sensors"
  },
  {
    "id": 144,
    "PaperID": 576,
    "Title": "Multi-Blockchain Backup & Restore System with Zero-Knowledge Proofs (ZKPs)"
  },
  {
    "id": 145,
    "PaperID": 578,
    "Title": "Transformer-Based Intrusion Detection for Securing Medical Applications in 5G IoMT Networks"
  },
  {
    "id": 146,
    "PaperID": 579,
    "Title": "An Adaptive AI Approach for Cervical Cancer Prediction with Explainability"
  },
  {
    "id": 147,
    "PaperID": 580,
    "Title": "Reconfigurable Circular Polarized Microstrip Patch Array Antenna with Half-Wavelength Delay Line Switching"
  },
  {
    "id": 148,
    "PaperID": 582,
    "Title": "A Secure and Transparent Fundraising Framework Utilizing Blockchain and Smart Contracts"
  },
  {
    "id": 149,
    "PaperID": 584,
    "Title": "Advancing Electromyography Signal Analysis: Wavelet-Based Filtering for Low Back Pain Patients Assessment"
  },
  {
    "id": 150,
    "PaperID": 585,
    "Title": "Transformer and Deep Learning-based Depression Detection from Low-Resource Language."
  },
  {
    "id": 151,
    "PaperID": 587,
    "Title": "Optimal Selection of Antennas for Wireless Communication Based on Performance Criterion"
  },
  {
    "id": 152,
    "PaperID": 592,
    "Title": "DeepHateDetect: A Comparative Study of Traditional, Sequential, Transformer, and Large Language Models for Hate Speech Detection in Bengali using Explainable AI"
  },
  {
    "id": 153,
    "PaperID": 602,
    "Title": "Deep Feature Interaction Improves Knowledge Distillation From Classical to Quantum Neural Network"
  },
  {
    "id": 154,
    "PaperID": 604,
    "Title": "Enhancing Speech Emotion Recognition with Explainable AI and Feature Importance Analysis"
  },
  {
    "id": 155,
    "PaperID": 607,
    "Title": "AAT-SCYP: Advance Agriculture Technology for sustainable crop yield prediction and environmental sustainability using Machine Learning Algorithms."
  },
  {
    "id": 156,
    "PaperID": 612,
    "Title": "An Interpretable Ensemble Framework Towards Efficient Hypertension Risk Assessment"
  },
  {
    "id": 157,
    "PaperID": 614,
    "Title": "Crowd Counting using Single Branch Convolutional Neural Network"
  },
  {
    "id": 158,
    "PaperID": 624,
    "Title": "Area Efficient FPGA Implementation of Point Multiplication for Elliptic Curve Cryptography"
  },
  {
    "id": 159,
    "PaperID": 625,
    "Title": "Design and Performance Evaluation of an Ultra-Sensitive Plasmonic Sensor Using Photonic Crystal Fiber"
  },
  {
    "id": 160,
    "PaperID": 631,
    "Title": "Interpretable Deep Learning for Malaria Diagnosise Detection: A Self-Attention and XAI Framework"
  },
  {
    "id": 161,
    "PaperID": 635,
    "Title": "Mining Hidden Patterns in Student Dropout: Using Random Forest-Based Feature Selection and Association Rule Mining"
  },
  {
    "id": 162,
    "PaperID": 639,
    "Title": "Bengali Human Sentiment Detection and Classification using Attention based Bidirectional LSTM"
  },
  {
    "id": 163,
    "PaperID": 650,
    "Title": "An Explainable Ensemble Learning Approach for Gestational Diabetes Prediction"
  },
  {
    "id": 164,
    "PaperID": 654,
    "Title": "PotholeNet11:A YOLO11-Powered Real-Time Framework for Comprehensive Pothole Detection and Road Safety"
  },
  {
    "id": 165,
    "PaperID": 658,
    "Title": "Occupant-Centered Lighting and Shading Control Using Machine Learning on a Low-Cost Microcontroller"
  },
  {
    "id": 166,
    "PaperID": 669,
    "Title": "Towards Smart Diagnostic: A Multi-Disease Prediction System Leveraging Machine Learning Techniques"
  },
  {
    "id": 167,
    "PaperID": 670,
    "Title": "A Compression-Based Data Structure on MapReduce System for Data Warehouse Management"
  },
  {
    "id": 168,
    "PaperID": 678,
    "Title": "SHAP-Driven Machine Learning Models for Predicting Structural Component Capacity"
  },
  {
    "id": 169,
    "PaperID": 679,
    "Title": "A Miniaturized Dual-Element Microstrip Patch Antenna Array for Multi-Band 6G Terahertz Applications"
  },
  {
    "id": 170,
    "PaperID": 690,
    "Title": "Deep Learning-Based Classification of Potato Leaf Diseases for Sustainable Agriculture"
  },
  {
    "id": 171,
    "PaperID": 701,
    "Title": "A Facial Gesture-Controlled Wheelchair for Individuals with Complete Disabilities"
  },
  {
    "id": 172,
    "PaperID": 703,
    "Title": "RAPID: Resilient Automated Planning for Intelligent Disaster Response"
  },
  {
    "id": 173,
    "PaperID": 713,
    "Title": "Machine Translation"
  }
]